(function changePasswordControllerDefinition() {

    'use strict';

    angular.module('Profile')
        .controller('UserImpersonationController', [
             '$scope', 'authExtend', '$translate', '$q', 'config', '$state', '$stateParams', 'errorsExtend', 'diff',
            'adminUserService', 'login',
            function userImpersonationController($scope, auth, $translate, $q, config, $state, $stateParams, errors, diff,
                                              adminUserService, login) {

                $translate(['ProfileImpersonation']).then(function (translated) {
                    $scope.title = translated.ProfileImpersonation;
                });

                $scope.userImp = {
                    nickName: ''
                };

                $scope.requiredOu = true;
                $scope.undoEnabled = auth.getCreationOuId() === auth.getOrganizationId() ? true : false;


                adminUserService.getUserImpersonation(auth.getUserId()).then(function (result) {
                    if (result.value.length > 0) {
                        $scope.userImp = result.value[0];
                    } else {
                        errors.showError('NoFound');
                        $state.go('inicio');
                    }
                }, function (error) {
                    errors.showError(error);
                    $state.go('inicio');
                });

                function refresh() {

                    auth.refreshToken()
                        .then(function (result) {
                            if (!result) {
                                login.logOut();
                                return;
                            }
                        },
                            function () {
                                login.logOut();
                            });
                }
                $scope.save = function () {

                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return adminUserService.createUserImpersonation($scope.userImp).then(function getOk(result) {
                        errors.showSuccess('ProfileImpersonationSucces');

                        refresh();

                        $state.go('inicio');
                    },
                       function (error) {
                           errors.showError(error);
                       });
                }
                $scope.cancel = function () {
                    $state.go("inicio");
                };


                $scope.undoImper = function () {

                    $scope.userImp.impersonationId = auth.getCreationOuId();

                    return adminUserService.createUserImpersonation($scope.userImp).then(function getOk(result) {
                        errors.showSuccess('ProfileImpersonationSucces');

                        refresh();

                        $state.go('inicio');
                    },
                       function (error) {
                           errors.showError(error);
                       });
                }


            }
        ]);
})();